/* ==========================================================================
   CUERA — motor de movimiento e interacción
   Portado de web-produccion/cuera-motion.js (export de Claude Design).

   Todas las curvas y constantes del original se conservan EXACTAS:
     · reveal  .9s cubic-bezier(.22,1,.36,1) · opacity 0 / translateY(10px) / blur(5px)
     · IntersectionObserver threshold 0.1 · sólo prepara si rect.top > vh*0.9
     · scroll suave lerp 0.1 sobre document.scrollingElement, sólo (pointer:fine)
     · parallax prog = (box.top + box.height/2 - vh/2)/vh  ·  ty = prog*f*-vh
     · chip sticky a top <= 126px  →  [data-bko] de 9px a 0
     · buybar visible si heroCta.bottom < 0 && cierre.top > vh*0.9
     · telón [data-curtain]/[data-strip] 0 → 50% en hover
     · menú móvil [data-menu-btn] / [data-menu]

   Cambios respecto al original (obligatorios en Shopify):
     a) El carrito es REAL: /cart/add.js + /cart.js, fix doble-add, 422 visible,
        handlers expuestos como window.* y delegación de eventos en document
        (el drawer se re-renderiza por innerHTML y mataría los listeners).
     b) Se re-inicializa con shopify:section:load / :unload / :select.
     c) En Shopify.designMode NO se esconden los [data-anim] y se apaga el
        scroll suave de la rueda (pelea con el editor).
     d) Respeta prefers-reduced-motion y los settings de movimiento de Liquid.

   ⚠️ ESTE ARCHIVO ES UN SCRIPT CLÁSICO, NO UN MÓDULO ES.
   Se carga con <script src="..."></script> SIN type="module" (layout/theme.liquid).
   Motivos, los dos medidos:
     · type="module" implica CORS: en file:// el navegador lo bloquea entero y la
       página se queda sin movimiento, sin bolsa y sin barra de compra.
     · type="module" es diferido: se ejecuta después de que Liquid ya pintó, y
       window.CUERA_OPCIONES / los onclick="window.cueraX(...)" del markup
       quedaban indefinidos durante el primer pintado.
   No hay ni un import ni un export en este archivo, a propósito. Todo lo que el
   markup necesita se publica en window: window.CUERA, window.initCuera y los
   handlers window.cueraAgregar / cueraAbrirBolsa / cueraCerrarBolsa /
   cueraQuitar / cueraCantidad / cueraPagar / cueraCopiarCodigo /
   cueraGaleria.
   ========================================================================== */
(function () {
  'use strict';

  var EASE = 'cubic-bezier(.22,1,.36,1)';
  var CHIP_TOP = 126;              // umbral sticky del chip de #senales
  var VARIANTE_FALLBACK = null;    // lo inyecta Liquid en window.CUERA_OPCIONES

  var opciones = {
    animaciones: true,
    scrollSuave: true,
    duracion: 900,     // ms — reveal
    desplazamiento: 10, // px — translateY inicial
    desenfoque: 5,      // px — blur inicial
    variante: null,     // id de variante por defecto para [data-add]
    seccionDrawer: null,// id de sección del drawer para Section Rendering API
    moneda: 'MXN'
  };

  var limpieza = [];
  var iniciado = false;
  var enEditor = !!(window.Shopify && window.Shopify.designMode);

  /* ---------------------------------------------------------------- utils */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* El formato del diseño: $1,799 MXN — sin espacio tras el $, sin decimales. */
  function dinero(centavos, conMoneda) {
    var n = (Number(centavos) || 0) / 100;
    var centavosSueltos = Math.round(Number(centavos) || 0) % 100 !== 0;
    var s;
    try {
      s = new Intl.NumberFormat('es-MX', {
        style: 'currency', currency: opciones.moneda,
        /* 23-sep: con centavos (MEXICANA10 da $1,799.10) se enseñan, para que
           el cajón diga lo mismo que el pago; los enteros siguen sin decimales. */
        minimumFractionDigits: centavosSueltos ? 2 : 0, maximumFractionDigits: centavosSueltos ? 2 : 0
      }).format(n);
    } catch (e) {
      s = '$' + (centavosSueltos ? n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : Math.round(n).toLocaleString('es-MX'));
    }
    s = s.replace(/\s/g, '').replace(/ /g, '');
    return conMoneda === false ? s : s + ' ' + opciones.moneda;
  }

  /* ------------------------------------------------------- 1. revelaciones */
  function revelaciones(anims) {
    // En el editor NUNCA se esconde nada: el comerciante vería la sección en blanco.
    if (!anims || enEditor) return;
    var els = $$('[data-anim]');
    var vh = window.innerHeight;
    var dur = (opciones.duracion / 1000) + 's';
    var dy = opciones.desplazamiento + 'px';
    var blur = opciones.desenfoque + 'px';
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          var el = entries[i].target;
          el.__cueraAnim = 'listo';
          el.style.opacity = '1';
          el.style.transform = 'translateY(0px)';
          el.style.filter = 'blur(0px)';
          io.unobserve(el);
        }
      }
    }, { threshold: 0.1 });
    els.forEach(function (el) {
      if (el.__cueraAnim === 'listo') return;   // ya se reveló: no volver a esconderlo
      var r = el.getBoundingClientRect();
      if (r.top > vh * 0.9) {
        el.__cueraAnim = 'preparado';
        el.style.transition =
          'opacity ' + dur + ' ' + EASE + ', transform ' + dur + ' ' + EASE + ', filter ' + dur + ' ' + EASE;
        el.style.transitionDelay = (el.getAttribute('data-anim') || '0') + 'ms';
        el.style.opacity = '0';
        el.style.transform = 'translateY(' + dy + ')';
        el.style.filter = 'blur(' + blur + ')';
        io.observe(el);
      }
    });
    limpieza.push(function () { io.disconnect(); });
  }

  /* ---------------------------------------------------- 2. scroll suave */
  function scrollSuave(anims) {
    // En el editor de temas el hijack pelea con el "saltar a sección".
    if (!anims || enEditor || !opciones.scrollSuave) return;
    if (!window.matchMedia('(pointer: fine)').matches) return;
    var scroller = document.scrollingElement;
    var target = scroller.scrollTop, current = target, raf = null;
    var max = function () { return scroller.scrollHeight - window.innerHeight; };
    var tick = function () {
      current += (target - current) * 0.1;
      if (Math.abs(target - current) < 0.5) { current = target; scroller.scrollTop = current; raf = null; return; }
      scroller.scrollTop = current;
      raf = requestAnimationFrame(tick);
    };
    var onWheel = function (e) {
      if (e.ctrlKey || e.metaKey || e.defaultPrevented) return;
      /* Carrusel horizontal (galería de la ficha en móvil): si el gesto va de
         lado y ese contenedor todavía tiene recorrido, la rueda es SUYA. Sin
         esta guarda el hijack vertical se comía el desplazamiento lateral en
         un navegador de escritorio angosto. El gesto vertical no se toca:
         cae al preventDefault de siempre y la página baja igual. */
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && e.target && e.target.closest) {
        var car = e.target.closest('[data-carrusel]');
        if (car && car.scrollWidth > car.clientWidth + 1) return;
      }
      e.preventDefault();
      target = Math.max(0, Math.min(max(), target + e.deltaY));
      if (!raf) raf = requestAnimationFrame(tick);
    };
    var onNative = function () { if (!raf) { target = scroller.scrollTop; current = target; } };
    window.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('scroll', onNative, { passive: true });
    limpieza.push(function () {
      window.removeEventListener('wheel', onWheel);
      window.removeEventListener('scroll', onNative);
      if (raf) cancelAnimationFrame(raf);
    });
  }

  /* -------------------------------------- 3+4+5. parallax / chip / buybar */
  function scrollLoop(anims) {
    var plx = $$('[data-plx]');
    var chips = $$('[data-chip]');
    var ticking = false;
    var frame = function () {
      ticking = false;
      var vh2 = window.innerHeight;
      if (anims) for (var i = 0; i < plx.length; i++) {
        var el = plx[i];
        var box = el.parentElement.getBoundingClientRect();
        if (box.bottom < -120 || box.top > vh2 + 120) continue;
        var f = parseFloat(el.getAttribute('data-plx')) || 0.08;
        var prog = (box.top + box.height / 2 - vh2 / 2) / vh2;
        el.style.transform = 'translateY(' + (prog * f * -vh2).toFixed(1) + 'px)';
      }
      for (var j = 0; j < chips.length; j++) {
        var chip = chips[j];
        var stuck = chip.getBoundingClientRect().top <= CHIP_TOP;
        if (chip._stuck !== stuck) {
          chip._stuck = stuck;
          $$('[data-bko]', chip).forEach(function (b) {
            b.style.width = stuck ? '0px' : '9px';
            b.style.opacity = stuck ? '0' : '1';
          });
        }
      }
      var buybar = $('[data-buybar]');
      var heroCta = $('[data-hero-cta]');
      var cierre = $('[data-cierre]');
      if (buybar && heroCta && cierre) {
        var hb = 0;
        $$('[id*="cuera-header"] > *').forEach(function (h) { var hr = h.getBoundingClientRect(); if (getComputedStyle(h).position === 'fixed' && hr.top <= 1 && hr.height < 200 && hr.bottom > hb) hb = hr.bottom; });
        /* 23-sep (Owen): en móvil con data-desde-inicio la barra se ve desde la
           primera pantalla y se esconde SOLO mientras el botón grande está a la
           vista, para que nunca haya dos «Añadir» en pantalla. */
        var desde = buybar.hasAttribute('data-desde-inicio') && window.innerWidth <= 820;
        var cta = heroCta.getBoundingClientRect();
        var ctaVisible = cta.bottom > hb && cta.top < vh2;
        var show = (desde ? !ctaVisible : cta.bottom < hb) && cierre.getBoundingClientRect().top > vh2 * 0.9;
        buybar.style.transform = show ? 'translateY(0px)' : 'translateY(110%)';
      }
    };
    var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    frame();
    limpieza.push(function () {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    });
  }

  /* ---------------------------------------------------------- 6. telones */
  /* Delegado en document: sobrevive al innerHTML del drawer. */
  function telones() {
    var onOver = function (e) {
      var el = e.target.closest && e.target.closest('[data-curtain]');
      if (!el) return;
      $$('[data-strip]', el).forEach(function (s) { s.style.width = '50%'; });
    };
    var onOut = function (e) {
      var el = e.target.closest && e.target.closest('[data-curtain]');
      if (!el) return;
      $$('[data-strip]', el).forEach(function (s) { s.style.width = '0px'; });
    };
    document.addEventListener('mouseover', onOver);
    document.addEventListener('mouseout', onOut);
    limpieza.push(function () {
      document.removeEventListener('mouseover', onOver);
      document.removeEventListener('mouseout', onOut);
    });
  }

  /* ------------------------------------------------------- 8. menú móvil */
  function menuMovil() {
    var onClick = function (e) {
      var btn = e.target.closest && e.target.closest('[data-menu-btn]');
      var menu = $('[data-menu]');
      if (!menu) return;
      if (btn) {
        var abrir = menu.style.display !== 'flex';
        menu.style.display = abrir ? 'flex' : 'none';
        if (btn.hasAttribute('data-menu-icono')) btn.setAttribute('aria-expanded', abrir ? 'true' : 'false');
        else btn.textContent = abrir ? 'Cerrar ✕' : 'Menú';
        return;
      }
      var enlace = e.target.closest && e.target.closest('[data-menu] a');
      if (enlace) {
        menu.style.display = 'none';
        var b = $('[data-menu-btn]');
        if (b && b.hasAttribute('data-menu-icono')) b.setAttribute('aria-expanded', 'false');
        else if (b) b.textContent = 'Menú';
      }
    };
    document.addEventListener('click', onClick);
    limpieza.push(function () { document.removeEventListener('click', onClick); });
  }

  /* --------------------------------------- 9. galería de la ficha (PDP) */
  /* Cambia la foto grande al tocar una miniatura.
     · Delegación en document, como los telones y la bolsa: la sección se
       re-renderiza entera (editor de temas y Section Rendering API) y un
       listener colgado del <button> moriría con ella.
     · Sin salto de layout: el <img> grande tiene width:100% + aspect-ratio 4/5,
       así que su caja no depende del archivo; sólo cambian src/srcset/alt.
     · Las medidas de la foto grande vienen ya resueltas en data-mini-*: copiar
       el srcset de la miniatura pondría un archivo de 400 px en un hueco de 723.
     · Funciona igual en Shopify.designMode — no esconde nada, así que no hay
       motivo para apagarla; y cada shopify:section:load vuelve a init(), que
       destruye el listener viejo antes de poner el nuevo (nunca se duplica). */
  window.cueraGaleria = function (btn) {
    if (!btn || !btn.closest) return false;
    var caja = btn.closest('[data-galeria]');
    if (!caja) return false;

    /* La foto grande vive en la misma columna que la galería; si el markup
       cambiara, se busca en toda la página antes de rendirse. */
    var col = caja.parentElement;
    var grande = col ? col.querySelector('[data-galeria-grande]') : null;
    if (!grande) grande = $('[data-galeria-grande]');
    if (!grande) return false;

    var src = btn.getAttribute('data-mini-src');
    if (!src) return false;
    var srcset = btn.getAttribute('data-mini-srcset') || '';
    var sizes = btn.getAttribute('data-mini-sizes') || '';
    var alt = btn.getAttribute('data-mini-alt');

    /* srcset y sizes SIEMPRE juntos: dejar un srcset viejo con un src nuevo
       haría que el navegador siguiera pintando la foto anterior. */
    if (srcset) {
      grande.setAttribute('srcset', srcset);
      if (sizes) grande.setAttribute('sizes', sizes);
    } else {
      grande.removeAttribute('srcset');
      grande.removeAttribute('sizes');
    }
    grande.setAttribute('src', src);
    if (alt !== null) grande.setAttribute('alt', alt);

    /* Marca la activa. `outline` y no `border` ni `box-shadow` inset: el
       outline se pinta DESPUÉS de los hijos (va encima de la foto) y no ocupa
       espacio, así que la retícula no se mueve ni un píxel. */
    var color = caja.getAttribute('data-galeria-activo') || '#C77B45';
    var botones = $$('[data-mini]', caja);
    for (var i = 0; i < botones.length; i++) {
      var activa = botones[i] === btn;
      botones[i].style.outline = activa ? ('2px solid ' + color) : '';
      botones[i].style.outlineOffset = activa ? '-2px' : '';
      botones[i].setAttribute('aria-current', activa ? 'true' : 'false');
    }
    return false;
  };

  function galeria() {
    /* Enter y Espacio no necesitan código: son <button type="button">, el
       navegador los convierte en click. */
    var onClick = function (e) {
      var btn = e.target.closest && e.target.closest('[data-mini]');
      if (!btn) return;
      e.preventDefault();
      window.cueraGaleria(btn);
    };
    document.addEventListener('click', onClick);

    /* TECLADO — al tabular hacia una miniatura que quedó fuera del corte del
       carrusel, hay que traerla a la vista. Se mueve SÓLO el carrusel
       (scrollBy sobre el contenedor); un scrollIntoView tocaría también el
       scroll vertical de la página y daría un salto. Si no hay recorrido
       horizontal (escritorio: la retícula 3x3) no hace absolutamente nada. */
    var onFoco = function (e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-mini]');
      if (!btn) return;
      var car = btn.closest('[data-carrusel]');
      if (!car || car.scrollWidth <= car.clientWidth + 1) return;
      var cr = car.getBoundingClientRect();
      var br = btn.getBoundingClientRect();
      var d = 0;
      if (br.left < cr.left) d = br.left - cr.left;
      else if (br.right > cr.right) d = br.right - cr.right;
      if (!d) return;
      var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try { car.scrollBy({ left: d, behavior: suave ? 'smooth' : 'auto' }); }
      catch (err) { car.scrollLeft += d; }
    };
    document.addEventListener('focusin', onFoco);

    limpieza.push(function () {
      document.removeEventListener('click', onClick);
      document.removeEventListener('focusin', onFoco);
    });
  }

  /* ============================ 7. LA BOLSA — carrito real de Shopify ==== */

  var carrito = { item_count: 0, items: [], total_price: 0, items_subtotal_price: 0 };
  var __adding = false;   // fix doble-add: click y submit disparan juntos
  var __mutando = false;  // una sola mutación de carrito en vuelo a la vez
  var __regalo = false;   // bandera propia del regalo: nunca entra dos veces
  var __vaciarTimer = null;

  function abrirBolsa() {
    var d = $('[data-drawer]'), v = $('[data-veil]');
    if (d) d.style.transform = 'translateX(0%)';
    if (v) { v.style.opacity = '1'; v.style.pointerEvents = 'auto'; }
  }
  function cerrarBolsa() {
    var d = $('[data-drawer]'), v = $('[data-veil]');
    if (d) d.style.transform = 'translateX(105%)';
    if (v) { v.style.opacity = '0'; v.style.pointerEvents = 'none'; }
  }

  function error(msg) {
    var caja = $('[data-cart-error]');
    if (caja) {
      caja.textContent = msg;
      caja.style.display = msg ? 'block' : 'none';
    } else if (msg) {
      window.alert(msg);
    }
  }

  /* Pinta contadores y estados vacío/lleno. Siempre seguro de llamar. */
  function pintarContadores() {
    var n = carrito.item_count || 0;
    $$('[data-bag-count]').forEach(function (c) { c.textContent = (c.getAttribute('data-bag-label') || 'Carrito') + ' (' + n + ')'; });
    $$('[data-cart-n]').forEach(function (c) { c.textContent = String(n); });
    $$('[data-cart-badge]').forEach(function (c) { c.textContent = String(n); c.style.display = n > 0 ? '' : 'none'; });
    var drawer = $('[data-drawer]');
    if (!drawer) return;
    var vacio = $('[data-cart-empty]', drawer);
    var lleno = $('[data-cart-full]', drawer);
    if (vacio) vacio.style.display = n ? 'none' : 'flex';
    if (lleno) lleno.style.display = n ? 'flex' : 'none';
  }

  function esc(t) {
    return String(t == null ? '' : t)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* La configuración del cajón la publica sections/cuera-drawer.liquid en un
     <script> que vive FUERA de [data-drawer-inner], así que sobrevive a
     cualquier innerHTML. Si no está, todo cae a valores del diseño. */
  function cfg() { return window.CUERA_BOLSA || {}; }

  /* RESPALDO del repintado: construye las líneas DESDE /cart.js con los MISMOS
     controles que emite el Liquid (− / cantidad / + / Quitar, 34 px de alto).
     Se usa cuando la Section Rendering API no contesta, contesta sin
     [data-drawer-inner], o devuelve un cajón que no cuadra con el carrito real.
     Antes este camino dependía de un <template data-cart-tpl> que no existía en
     ninguna sección: el respaldo no pintaba nada. */
  function pintarLineas() {
    var drawer = $('[data-drawer]');
    if (!drawer) return;
    var c = cfg(), col = c.col || {}, txt = c.txt || {}, reg = c.reg || {};
    var acento = col.acento || '#571E14';
    var suave = col.suave || '#7A5B47';
    var bl = '1px solid rgba(87,30,20,.2)';
    var bb = '1px solid rgba(87,30,20,.3)';
    var serif = "font-family:'Libre Caslon Text',serif;";
    var lista = $('[data-cart-lineas]', drawer);
    if (lista) {
      var html = '';
      var regaloId = Number(c.regalo || 0);
      var regaloDentro = false;
      (carrito.items || []).forEach(function (it) {
        if (regaloId && Number(it.variant_id) === regaloId) { regaloDentro = true; return; }
        var nombre = it.product_title || it.title || '';
        if (c.acortar !== false) nombre = nombre.split(' · ')[0];
        var foto = it.image || c.respaldoFoto || '';
        var pieza = it.quantity === 1 ? (txt.pieza || 'pieza') : (txt.piezas || 'piezas');
        html += '<div data-linea="1" data-linea-key="' + esc(it.key) + '" style="display:flex;gap:14px;border-bottom:' + bl + ';padding-bottom:16px;">'
          + (foto ? '<img src="' + esc(foto) + '" alt="' + esc(nombre) + '" loading="lazy" decoding="async" style="width:76px;height:96px;object-fit:cover;">' : '')
          + '<div style="display:flex;flex-direction:column;gap:4px;flex:1;min-width:0;">'
          + '<div style="display:flex;justify-content:space-between;gap:10px;"><span style="' + serif + 'font-size:16px;">' + esc(nombre)
          + '</span><span data-linea-precio="1" style="' + serif + 'font-size:16px;color:' + acento + ';white-space:nowrap;">' + dinero(it.final_line_price, false) + '</span></div>'
          + '<div style="font-size:11px;color:' + acento + ';">' + esc(txt.nota || '') + ' · ' + it.quantity + ' ' + esc(pieza) + '</div>'
          + '<div style="font-size:11px;color:' + suave + ';">' + esc(txt.nota2 || '') + '</div>';
        if (c.controles !== false || c.quitar !== false) {
          html += '<div style="display:flex;align-items:center;gap:10px;margin-top:6px;flex-wrap:wrap;">';
          if (c.controles !== false) {
            html += '<div style="display:flex;align-items:center;border:' + bb + ';">'
              + '<div data-linea-menos="1" role="button" tabindex="0" aria-label="' + esc(txt.menosAria || 'Quitar una pieza')
              + '" style="width:34px;height:34px;display:grid;place-items:center;cursor:' + (it.quantity > 1 ? 'pointer' : 'not-allowed')
              + ';font-size:16px;font-weight:700;line-height:1;color:' + acento + ';opacity:' + (it.quantity > 1 ? '1' : '.35') + ';user-select:none;-webkit-user-select:none;">−</div>'
              + '<div data-linea-qty="1" style="min-width:32px;height:34px;display:grid;place-items:center;font-size:13px;font-weight:700;border-left:' + bb + ';border-right:' + bb + ';">' + it.quantity + '</div>'
              + '<div data-linea-mas="1" role="button" tabindex="0" aria-label="' + esc(txt.masAria || 'Añadir una pieza')
              + '" style="width:34px;height:34px;display:grid;place-items:center;cursor:pointer;font-size:16px;font-weight:700;line-height:1;color:' + acento + ';user-select:none;-webkit-user-select:none;">+</div>'
              + '</div>';
          }
          if (c.quitar !== false) {
            html += '<div data-linea-quitar="1" role="button" tabindex="0" style="height:34px;display:inline-flex;align-items:center;padding:0 12px;border:' + bb
              + ';cursor:pointer;font-weight:700;font-size:10.5px;letter-spacing:.08em;text-transform:uppercase;color:' + suave
              + ';user-select:none;-webkit-user-select:none;">' + esc(txt.quitar || 'Quitar') + '</div>';
          }
          html += '</div>';
        }
        html += '</div></div>';
      });
      if (reg.mostrar !== false && (reg.titulo || regaloDentro)) {
        var antes = reg.antes ? '<span style="text-decoration:line-through;color:' + suave + ';font-weight:400;margin-right:6px;">' + esc(reg.antes) + '</span>' : '';
        html += '<div' + (regaloDentro ? ' data-linea-regalo="1"' : '') + ' style="display:flex;gap:14px;border-bottom:' + bl + ';padding-bottom:14px;">'
          + '<div style="width:76px;height:56px;background:' + (col.regaloFondo || '#EDE0CB') + ';display:grid;place-items:center;flex:none;">'
          + (reg.foto ? '<img src="' + esc(reg.foto) + '" alt="' + esc(reg.titulo || '') + '" loading="lazy" decoding="async" style="width:76px;height:56px;object-fit:cover;display:block;">' : '')
          + '</div><div style="display:flex;flex-direction:column;gap:3px;flex:1;min-width:0;">'
          + '<div style="display:flex;justify-content:space-between;gap:10px;"><span style="font-size:13px;font-weight:700;">' + esc(reg.titulo || '')
          + '</span><span style="font-size:13px;font-weight:700;color:' + acento + ';white-space:nowrap;">' + antes + esc(reg.precio || '') + '</span></div>'
          + '<div style="font-size:11px;color:' + suave + ';">' + esc(regaloDentro ? (reg.notaDentro || '') : (reg.nota || '')) + '</div>'
          + '</div></div>';
      }
      lista.innerHTML = html;
    }
    var sub = $('[data-cart-subtotal]', drawer);
    if (sub) sub.textContent = dinero(carrito.items_subtotal_price);
    /* Mismo redondeo que el Liquid: al peso más cercano, nunca al centavo. */
    var pct = Number(c.descuentoPct || 0);
    var desc = pct > 0 ? Math.round(carrito.items_subtotal_price * pct / 10000) * 100 : 0;
    var filaD = $('[data-cart-fila-descuento]', drawer);
    var spanD = $('[data-cart-descuento]', drawer);
    if (filaD) filaD.style.display = desc > 0 ? 'flex' : 'none';
    if (spanD) spanD.textContent = '−' + dinero(desc, false);
    /* Descuentos REALES ya aplicados (MEXICANA10 por /cart/update.js): el Liquid
       los pinta y este respaldo no. Sin esta fila el cajón decía Subtotal $1,999
       y Total $1,799.10 sin explicar la diferencia (cro-arte, 8-oct-2026). */
    if (sub && sub.parentNode) {
      $$('[data-lt-desc]', drawer).forEach(function (n) { n.parentNode.removeChild(n); });
      var ancla = sub.parentNode;
      (carrito.cart_level_discount_applications || []).slice().reverse().forEach(function (d) {
        var fila = document.createElement('div');
        fila.setAttribute('data-lt-desc', '1');
        fila.style.cssText = 'display:flex;justify-content:space-between;font-size:13px;';
        fila.innerHTML = '<span>' + esc(d.title) + '</span><span style="font-weight:700;">\u2212' + dinero(d.total_allocated_amount, false) + '</span>';
        ancla.parentNode.insertBefore(fila, ancla.nextSibling);
      });
    }
    var tot = $('[data-cart-total]', drawer);
    if (tot) tot.textContent = dinero(desc > 0 ? (carrito.items_subtotal_price - desc) : carrito.total_price);
    pintarContadores();
  }

  /* Section Rendering API — camino preferido cuando el drawer vive en un
     section group. Reemplaza el interior de [data-drawer-inner] con el HTML
     que devuelve Shopify, así el Liquid del drawer manda sobre el JS.

     Dos cosas que aprendimos a golpes:
      a) hay que conservar location.search — sin ?preview_theme_id la vista
         previa pediría la sección al tema PUBLICADO, otro cajón distinto;
      b) hay que COMPROBAR el resultado: si el HTML devuelto no trae tantas
         [data-linea] como líneas de pago tiene /cart.js, se pinta a mano. */
  function refrescarSeccion() {
    var id = opciones.seccionDrawer;
    var inner = $('[data-drawer-inner]');
    if (!id || !inner) { pintarLineas(); return Promise.resolve(); }
    var q = window.location.search ? window.location.search + '&' : '?';
    var url = window.location.pathname + q + 'sections=' + encodeURIComponent(id);
    /* Vista previa de un tema sin publicar: la Section Rendering API responde con
       el tema EN VIVO (medido 8-oct-2026, aun con la cookie de vista previa) y el
       cajón salía con el diseño viejo. En vista previa se pinta desde /cart.js. */
    var tema = window.Shopify && window.Shopify.theme;
    if (tema && tema.role && tema.role !== 'main') { return leerCarrito().then(function () { pintarLineas(); pintarContadores(); }); }
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var html = data && data[id];
        if (!html) { pintarLineas(); return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nuevo = doc.querySelector('[data-drawer-inner]');
        if (!nuevo) { pintarLineas(); return; }
        inner.innerHTML = nuevo.innerHTML;
        pintarContadores();
        var regaloId = Number(cfg().regalo || 0);
        var esperadas = 0;
        (carrito.items || []).forEach(function (i) {
          if (!regaloId || Number(i.variant_id) !== regaloId) esperadas++;
        });
        if ($$('[data-linea]', inner).length !== esperadas) pintarLineas();
      })
      .catch(function () { pintarLineas(); });
  }

  function leerCarrito() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { carrito = c; pintarContadores(); return c; });
  }

  /* El regalo (data-regalo="<id de variante>") entra en una SEGUNDA petición,
     nunca en el mismo /cart/add.js: si la cosmetiquera se quedara sin stock, un
     add múltiple es atómico y tumbaría también la compra de La Leonesa.
     Si ya está en la bolsa no se vuelve a añadir — no se acumula. */
  function agregarRegalo(regaloId) {
    var g = Number(regaloId);
    if (!g) return Promise.resolve();
    var yaEsta = false;
    (carrito.items || []).forEach(function (i) { if (Number(i.variant_id) === g) yaEsta = true; });
    if (yaEsta) return Promise.resolve();
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: g, quantity: 1 }] })
    })
      .then(function (r) { return r.ok ? leerCarrito() : null; })   // sin stock: se calla
      .catch(function () {});
  }

  /* EL REGALO, de verdad.
     Regla dura: entra sólo si hay al menos un producto de pago en la bolsa y
     todavía no está; y se va con ellos si el cliente se queda sin nada de pago
     (no dejamos un regalo suelto de $0 llegando al checkout). Bandera __regalo
     contra el doble-add. Devuelve true si tocó el carrito, para que quien la
     llame repinte una vez más. */
  function sincronizarRegalo() {
    var c = cfg();
    var g = Number(c.regalo || 0);
    if (!g || c.regaloAuto === false || __regalo) return Promise.resolve(false);
    var suyo = null, otros = 0;
    (carrito.items || []).forEach(function (i) {
      if (Number(i.variant_id) === g) { suyo = i; } else { otros++; }
    });
    var cuerpo = null;
    if (otros > 0 && !suyo) {
      cuerpo = { url: '/cart/add.js', body: { items: [{ id: g, quantity: 1 }] } };
    } else if (otros === 0 && suyo && c.regaloSeVaSolo !== false) {
      cuerpo = { url: '/cart/change.js', body: { id: suyo.key, quantity: 0 } };
    }
    if (!cuerpo) return Promise.resolve(false);
    __regalo = true;
    return fetch(cuerpo.url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo.body)
    })
      .then(function (r) { return r.ok ? leerCarrito() : null; })   // sin stock: se calla
      .then(function () { __regalo = false; return true; })
      .catch(function () { __regalo = false; return false; });
  }

  /* Vaciar la bolsa entera. El aviso de «¿seguro?» lo da el propio botón
     (window.cueraVaciar), nunca un confirm() del navegador. */
  function vaciar() {
    if (__mutando) return Promise.resolve();
    __mutando = true;
    error('');
    return fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { carrito = c; pintarContadores(); return refrescarSeccion(); })
      .catch(function () { error('No se pudo vaciar la bolsa. Intenta de nuevo.'); })
      .then(function () { __mutando = false; });
  }

  /* 23-sep-2026 (Owen): el código del lanzamiento se aplica EN SHOPIFY al
     añadir (/cart/update.js con discount), así el cajón y el pago cobran lo
     mismo. Si ya está aplicado no se repite. Un fallo aquí no frena la compra. */
  function aplicarCodigo() {
    var cod = String(cfg().codigoAuto || '').trim();
    if (!cod) return Promise.resolve();
    var ya = (carrito && carrito.discount_codes || []).some(function (d) { return d && String(d.code).toUpperCase() === cod.toUpperCase(); });
    if (ya) return Promise.resolve();
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: cod })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) { carrito = c; pintarContadores(); } })
      .catch(function () {});
  }

  function agregar(variantId, cantidad, regaloId) {
    if (__adding) return Promise.resolve();
    var id = Number(variantId || opciones.variante || VARIANTE_FALLBACK);
    if (!id) { error('No hay variante configurada para este botón.'); return Promise.resolve(); }
    __adding = true;
    error('');
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: Number(cantidad) || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, status: r.status, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {                                   // 422 = inventario u otro error
          error((res.data && (res.data.description || res.data.message)) || 'No se pudo agregar a la bolsa.');
          return;
        }
        return leerCarrito()
          .then(function () { return agregarRegalo(regaloId); })
          .then(sincronizarRegalo)
          .then(aplicarCodigo)
          .then(refrescarSeccion)
          .then(abrirBolsa);
      })
      .catch(function () { error('No se pudo conectar con la tienda. Intenta de nuevo.'); })
      .then(function () { __adding = false; });
  }

  function cambiar(key, cantidad) {
    if (__mutando) return Promise.resolve();
    __mutando = true;
    error('');
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Number(cantidad) })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { error((res.data && (res.data.description || res.data.message)) || 'No se pudo actualizar la bolsa.'); return; }
        carrito = res.data; pintarContadores();
        return sincronizarRegalo().then(refrescarSeccion);
      })
      .catch(function () { error('No se pudo conectar con la tienda. Intenta de nuevo.'); })
      .then(function () { __mutando = false; });
  }

  function pagar() {
    var cod = String(cfg().codigoAuto || '').trim();
    window.location.href = '/checkout' + (cod ? '?discount=' + encodeURIComponent(cod) : '');
  }

  /* Handlers globales — el markup puede llamarlos con onclick="window.cueraX(this)"
     y sobreviven a cualquier innerHTML. */
  window.cueraAgregar = function (el) {
    var v = el && el.getAttribute && el.getAttribute('data-variante');
    var q = el && el.getAttribute && el.getAttribute('data-cantidad');
    var g = el && el.getAttribute && el.getAttribute('data-regalo');
    agregar(v, q, g);
    return false;
  };
  window.cueraAbrirBolsa = function () { abrirBolsa(); return false; };
  window.cueraCerrarBolsa = function () { cerrarBolsa(); return false; };
  window.cueraQuitar = function (el) {
    var fila = el && el.closest && el.closest('[data-linea-key]');
    if (fila) cambiar(fila.getAttribute('data-linea-key'), 0);
    return false;
  };
  /* El «−» NUNCA borra la línea: se planta en 1. Para sacarla está «Quitar».
     Era justo el caso de Owen: añadió dos sin querer y no tenía cómo bajar. */
  window.cueraCantidad = function (el, delta) {
    var fila = el && el.closest && el.closest('[data-linea-key]');
    if (!fila) return false;
    var key = fila.getAttribute('data-linea-key');
    var actual = 0;
    (carrito.items || []).forEach(function (i) { if (i.key === key) actual = i.quantity; });
    var nueva = actual + Number(delta || 0);
    if (nueva < 1 || nueva === actual) return false;
    cambiar(key, nueva);
    return false;
  };
  /* Confirmación EN EL BOTÓN, en dos toques. Nada de confirm() del navegador:
     rompe el tono de la marca y en móvil aparece pegado a la barra del sistema.
     Si nadie vuelve a tocarlo en 4 s, el botón se arrepiente solo. */
  window.cueraVaciar = function (el) {
    if (!el) { vaciar(); return false; }
    var c = cfg(), col = c.col || {}, txt = c.txt || {};
    if (el.__armado) {
      clearTimeout(__vaciarTimer);
      el.__armado = false;
      vaciar();
      return false;
    }
    el.__armado = true;
    el.textContent = el.getAttribute('data-confirmar') || txt.confirmar || '\u00bfSeguro? Toca otra vez';
    el.style.color = col.acento || '#571E14';
    el.style.borderColor = 'rgba(87,30,20,.6)';
    clearTimeout(__vaciarTimer);
    __vaciarTimer = setTimeout(function () {
      el.__armado = false;
      el.textContent = el.getAttribute('data-texto') || txt.vaciar || 'Vaciar la bolsa';
      el.style.color = col.suave || '#7A5B47';
      el.style.borderColor = 'rgba(87,30,20,.3)';
    }, 4000);
    return false;
  };
  window.cueraPagar = function () { pagar(); return false; };

  /* =============== 9. COPIAR EL CÓDIGO DE DESCUENTO (sections/cuera-ficha-codigo) ==
     Global a propósito: el markup lo llama con onclick="return window.cueraCopiarCodigo(this)".
     Con addEventListener sobre el botón, cualquier repintado de la sección (Section
     Rendering API, editor de temas) se llevaría el listener por delante; el atributo
     onclick sobrevive porque viaja dentro del HTML.

     Tres caminos, de mejor a peor, y NINGUNO deja al visitante sin respuesta:
       1) navigator.clipboard.writeText — sólo existe en contexto seguro (https).
       2) <textarea> fuera de pantalla + document.execCommand('copy') — el clásico;
          funciona en http, en WebView y en Safari viejo. Necesita el gesto del
          usuario, que el propio clic nos da.
       3) Si ni eso: se deja el código SELECCIONADO y el botón dice que lo copie a
          mano. Un botón que no hace nada visible es peor que no tener botón.
     ================================================================================ */
  window.cueraCopiarCodigo = function (btn) {
    if (!btn || !btn.closest) return false;
    var caja = btn.closest('[data-codigo]');
    var campo = caja ? caja.querySelector('[data-codigo-valor]') : null;
    if (!campo) return false;
    var codigo = (campo.getAttribute('data-codigo-valor') || campo.textContent || '').replace(/^\s+|\s+$/g, '');
    if (!codigo) return false;

    var etiqueta = btn.querySelector('[data-codigo-etiqueta]') || btn;
    var normal = btn.getAttribute('data-txt') || 'Copiar';
    var listo = btn.getAttribute('data-txt-ok') || 'Copiado ✓';
    var manual = btn.getAttribute('data-txt-error') || 'Selecciónalo y copia';

    /* Siempre volvemos al texto de data-txt, nunca al que hubiera en pantalla:
       dos clics seguidos dejarían el botón congelado en «Copiado ✓». */
    function avisar(texto) {
      if (btn.__cueraCopiaTimer) clearTimeout(btn.__cueraCopiaTimer);
      etiqueta.textContent = texto;
      btn.__cueraCopiaTimer = setTimeout(function () {
        etiqueta.textContent = normal;
        btn.__cueraCopiaTimer = null;
      }, 2000);
    }

    function aMano() {
      try {
        var rango = document.createRange();
        rango.selectNodeContents(campo);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(rango);
      } catch (e) {}
      avisar(manual);
    }

    function respaldo() {
      var ta = document.createElement('textarea');
      ta.value = codigo;
      ta.setAttribute('readonly', 'readonly');
      /* position:fixed y opacity:0 — no mueve el scroll ni repinta el layout. */
      ta.style.position = 'fixed';
      ta.style.top = '0';
      ta.style.left = '0';
      ta.style.width = '1px';
      ta.style.height = '1px';
      ta.style.padding = '0';
      ta.style.border = '0';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      var ok = false;
      try {
        ta.focus();
        ta.select();
        if (ta.setSelectionRange) ta.setSelectionRange(0, codigo.length);
        ok = document.execCommand('copy');
      } catch (e) { ok = false; }
      document.body.removeChild(ta);
      if (ok) avisar(listo); else aMano();
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        navigator.clipboard.writeText(codigo).then(function () { avisar(listo); }, respaldo);
      } catch (e) { respaldo(); }
    } else {
      respaldo();
    }
    return false;
  };

  function bolsa() {
    var onClick = function (e) {
      var t = e.target;
      if (!t.closest) return;
      if (t.closest('[data-add]')) { e.preventDefault(); window.cueraAgregar(t.closest('[data-add]')); return; }
      if (t.closest('[data-bag-btn]')) { e.preventDefault(); abrirBolsa(); return; }
      if (t.closest('[data-drawer-close]')) { e.preventDefault(); cerrarBolsa(); return; }
      if (t.closest('[data-cart-checkout]')) { e.preventDefault(); pagar(); return; }
      if (t.closest('[data-linea-quitar]')) { e.preventDefault(); window.cueraQuitar(t.closest('[data-linea-quitar]')); return; }
      if (t.closest('[data-linea-menos]')) { e.preventDefault(); window.cueraCantidad(t.closest('[data-linea-menos]'), -1); return; }
      if (t.closest('[data-linea-mas]')) { e.preventDefault(); window.cueraCantidad(t.closest('[data-linea-mas]'), 1); return; }
      if (t.closest('[data-cart-vaciar]')) { e.preventDefault(); window.cueraVaciar(t.closest('[data-cart-vaciar]')); return; }
      if (t.closest('[data-veil]')) { cerrarBolsa(); return; }
    };
    var onKey = function (e) { if (e.key === 'Escape') cerrarBolsa(); };
    document.addEventListener('click', onClick);
    window.addEventListener('keydown', onKey);
    $$('[data-bag-btn],[data-add],[data-drawer-close]').forEach(function (b) { b.style.cursor = 'pointer'; });
    limpieza.push(function () {
      document.removeEventListener('click', onClick);
      window.removeEventListener('keydown', onKey);
    });
    // Estado inicial real del carrito de Shopify (0 si no hay tienda detrás).
    if (typeof fetch === 'function') {
      leerCarrito()
        .then(sincronizarRegalo)
        .then(function (cambio) { if (cambio) return refrescarSeccion(); })
        .catch(function () { pintarContadores(); });
    }
    else pintarContadores();
  }

  /* ---------------------------------------------------------------- init */
  function init(opts) {
    if (iniciado) destruir();
    var o = opts || window.CUERA_OPCIONES || {};
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) opciones[k] = o[k];

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var anims = (opciones.animaciones !== false) && !reduce;

    document.documentElement.classList.add('cuera-js');

    revelaciones(anims);
    scrollSuave(anims);
    scrollLoop(anims);
    telones();
    menuMovil();
    galeria();
    bolsa();

    iniciado = true;
    return destruir;
  }

  function destruir() {
    limpieza.forEach(function (fn) { try { fn(); } catch (e) {} });
    limpieza = [];
    iniciado = false;
  }

  /* Arranque nombrado: el mismo que expone la versión del sitio estático.
     Sirve para relanzar el motor a mano sin depender del objeto CUERA. */
  window.initCuera = init;

  window.CUERA = {
    init: init,
    destruir: destruir,
    dinero: dinero,
    agregar: agregar,
    agregarRegalo: agregarRegalo,
    cambiar: cambiar,
    vaciar: vaciar,
    sincronizarRegalo: sincronizarRegalo,
    pintarLineas: pintarLineas,
    refrescarSeccion: refrescarSeccion,
    abrirBolsa: abrirBolsa,
    cerrarBolsa: cerrarBolsa,
    galeria: function (btn) { return window.cueraGaleria(btn); },
    leerCarrito: leerCarrito,
    get carrito() { return carrito; },
    get opciones() { return opciones; }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Editor de temas: cada carga/descarga/selección de sección reengancha todo. */
  document.addEventListener('shopify:section:load', function () { init(); });
  document.addEventListener('shopify:section:unload', function () { init(); });
  document.addEventListener('shopify:section:select', function () { init(); });
  document.addEventListener('shopify:section:reorder', function () { init(); });
})();
